'use strict';

var RouteModuloBaseMixin = require("moduleFold/modulobase/scripts/mixins/RouteModuloBaseMixin");


/**
 * Registrazione delle route per il modulo bss/articoli
 *
 * @class
 * @param {type} $stateProvider
 * @param {type} $urlRouterProvider
 * @param {type} $locationProvider
 */

function ArticoliRoutes($stateProvider, $urlRouterProvider, $locationProvider){

  var self = {
        $stateProvider: $stateProvider,
        stato: "articoli",
        url: "/articoli?catstat",
        //templateUrl: "ricambiweb/articoli/scripts/templates/articoli.html",
        template: require("../templates/articoli.html"),
        controller: ["$http", "$q", "$timeout", "$interval", "$state", "$stateParams", "DSFactory", "GridFactory", "GridCfgFactory", "ToolbarSrv", "identifica", "$scope", "$compile", "ActionFactory", "ErrorManager", "ArticoliFunzioniAggiuntive", require("../ArticoliCtrl")],
        //controllerAs
        //middleware
        //data
        //identifica
    };

    angular.extend(self, RouteModuloBaseMixin.prototype);
    self.registra();
}

module.exports = ArticoliRoutes;
